import { NgModule } from '@angular/core';

import { DataListCommandComponent } from '@shared/components/data-list/data-list-command/data-list-command.component';
import { InfiniteDatalistComponent } from '@shared/components/data-list/infinite-data-list/infinite-data-list.component';
import { PagedDataListComponent } from '@shared/components/data-list/paged-data-list/paged-data-list.component';

@NgModule({
  imports: [InfiniteDatalistComponent, PagedDataListComponent, DataListCommandComponent],
  exports: [InfiniteDatalistComponent, PagedDataListComponent, DataListCommandComponent],
})
export class DataListModule {}
